module.exports = __webpack_public_path__ + "img/Bank-Sina.b02b534.webp";